import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

export default (exclusionReasonTypeId, lastPhoto, imageTypes) => {
    const { typesList } = useSelector((state) => state);
    const [selectedImageType, setSelectedImageType] = useState(null);

    useEffect(() => {
        if (exclusionReasonTypeId) {
            const { exclusionImageTypes } = typesList;
            const exclusionImageType = exclusionImageTypes.data.find(
                (item) => item.exclusionReasonId === exclusionReasonTypeId
            );
            if (exclusionImageType) {
                const next = imageTypes.find(
                    (item) => item.id === exclusionImageType.imageTypeId
                );
                setSelectedImageType(next);
                return;
            }
        } else if (lastPhoto) {
            const index = imageTypes.findIndex(
                (item) => item.id === lastPhoto.imageType
            );
            const next = imageTypes[index + 1] || imageTypes[0];
            setSelectedImageType(next);
            return;
        }
        setSelectedImageType(imageTypes[0]);
    }, [exclusionReasonTypeId, imageTypes, lastPhoto, typesList]);

    return selectedImageType;
};
